

/* Constants for FB messenger related components */

module.exports = {
    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
    MOBILE_CHANNEL: 'MOBILE',
    WEB_CHANNEL: 'WEB',
    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
    FB_PROD_APP_ID: '1084613224964631',
    FB_PROD_PAGE_ID: {
        US: '55982004572',
        AU: '171522459698178',
        CA: '164660263560926',
        GB: '167465479930420',
        HK: '575224445931086',
        JP: '252040838174046',
        NZ: '171522459698178',
        PH: '1895483750701842',
        SG: '1405303076421245'
    },
    FB_TEST_PAGE_ID: '676472402496128',
    PXP_MESSENGER_EXPT: 'xo_wps_fb_messenger_plugin',
    PXP_SHOW_MESSENGER_PLUGIN_TREATMENT: 'xo_wps_fb_messenger_plugin_1_treatment',
    PXP_MESSENGER_HK: 'xo_wps_fb_messenger_plugin_HK',
    PXP_MESSENGER_PLUGIN_TREATMENT_HK: 'xo_wps_fb_messenger_plugin_HK_treatment',
    PXP_MESSENGER_JP: 'xo_wps_fb_messenger_plugin_JP',
    PXP_MESSENGER_PLUGIN_TREATMENT_JP: 'xo_wps_fb_messenger_plugin_JP_treatment',
    PXP_MESSENGER_SG: 'xo_wps_fb_messenger_plugin_SG',
    PXP_MESSENGER_PLUGIN_TREATMENT_SG: 'xo_wps_fb_messenger_plugin_SG_treatment',
    PXP_MESSENGER_PH: 'xo_wps_fb_messenger_plugin_PH',
    PXP_MESSENGER_PLUGIN_TREATMENT_PH: 'xo_wps_fb_messenger_plugin_PH_treatment'
};


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/constants/fbMessenger.js
// module id = ./components/xo-page-components/src/constants/fbMessenger.js
// module chunks = 1